import { Injectable } from '@angular/core';
import { RESTServiceBase } from '../../common/service.base';
import { DataEntryManifestDescriptor } from './model/dataentry';
import { List } from '../../common/model/List_T';
import { AppConfig } from '../../configuration/app.config';
import { AuthService } from '../../services/auth.service';
import { View } from '../../common/model/view';

@Injectable()
export class DataEntryManifestService extends RESTServiceBase {

  constructor(
    authService: AuthService,
    config: AppConfig,
  ) {
    super(
      'v1',
      'DataEntryManifestManagement',
      authService,
      config.DEMSConfig
    );
  }

  public getDataEntryManifests(view?: View): Promise<List<DataEntryManifestDescriptor>> {
    return super.get<List<DataEntryManifestDescriptor>>(undefined, view);
  }

  public getSize(id: string): Promise<Number> {
    return super.get<number>(id, undefined, "size");
  }

  public getSizeByDataEntryId(dataEntryId: string): Promise<number> {
    return super.get<number>(undefined, undefined, `sizebydataentryid/${dataEntryId}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dataentry/dataentry.manifest.service.ts